<template>
  <div>
    <b-modal id="modal-edit" size="lg" centered :title="$store.state.modal.editShift" header-bg-variant="warning" header-text-variant="light" @show="showModal()">
      <b-form>
        <b-form-group v-if="$store.state.role_aktif.kodeRole == 'super'" label="Nama Mitra" label-cols-md="3">
          <multiselect
            v-model="$v.data.mitra.$model"
            :state="checkIfValid('mitra')"
            :options="listMitra"
            @input="getKoordinators(data.mitra), (data.koordinator = null), (data.cabang = null)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaMitra"
            placeholder="-- Pilih --"
            disabled
          ></multiselect>
        </b-form-group>
        <b-form-group label="Nama Koordinator" label-cols-md="3">
          <multiselect
            v-model="$v.data.koordinator.$model"
            :state="checkIfValid('koordinator')"
            :options="listKoordinator"
            @input="getCabangs(data.koordinator), (data.cabang = null)"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaKoordinator"
            placeholder="-- Pilih --"
            disabled
          ></multiselect>
        </b-form-group>
        <b-form-group label="Nama Cabang" label-cols-md="3">
          <multiselect
            v-model="$v.data.cabang.$model"
            :state="checkIfValid('cabang')"
            :options="listCabang"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            :show-labels="false"
            label="namaCabang"
            placeholder="-- Pilih --"
          ></multiselect>
        </b-form-group>
        <b-form-group label="Lembur" label-cols-md="3">
          <Multiselect
            v-model="$v.data.lembur.$model"
            :state="checkIfValid('lembur')"
            :options="listLembur"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            label="namaLembur"
            track-by="id"
            placeholder="-- Pilih Lembur --"
            v-on:keydown.enter.prevent="simpan()"
            :disabled="!data.kategoriShift || (data.kategoriShift && !data.kategoriShift.lembur)"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Kategori" label-cols-md="3">
          <Multiselect
            v-model="$v.data.kategoriShift.$model"
            :state="checkIfValid('kategoriShift')"
            :options="listKategoriShift"
            :multiple="false"
            :searchable="true"
            :close-on-select="true"
            label="namaKategoriShift"
            track-by="namaKategoriShift"
            placeholder="-- Pilih Kategori --"
            v-on:keydown.enter.prevent="simpan()"
            @input="data.lembur = null"
          ></Multiselect>
        </b-form-group>
        <b-form-group label="Nama Shift" label-cols-md="3">
          <b-form-input type="text" :state="checkIfValid('namaShift')" v-model="$v.data.namaShift.$model" placeholder="nama shift" v-on:keydown.enter.prevent="simpan()"></b-form-input>
        </b-form-group>
        <b-form-group label="Jam Kerja" label-cols-md="3">
          <CRow>
            <CCol col="6">
              <b-form-timepicker
                locale="id"
                :state="checkIfValid('jamMasuk')"
                v-model="$v.data.jamMasuk.$model"
                placeholder="-- Jam Masuk --"
                v-on:keydown.enter.prevent="simpan()"
              ></b-form-timepicker>
            </CCol>
            <CCol col="6">
              <b-form-timepicker
                locale="id"
                :state="checkIfValid('jamKeluar')"
                v-model="$v.data.jamKeluar.$model"
                placeholder="-- Jam Keluar --"
                v-on:keydown.enter.prevent="simpan()"
              ></b-form-timepicker>
            </CCol>
          </CRow>
        </b-form-group>
        <b-form-group label="Nominal Upah" label-cols-md="3">
          <b-form-input
            type="number"
            :state="checkIfValid('nominalUpah')"
            v-model="$v.data.nominalUpah.$model"
            locale="id"
            placeholder="Nominal Upah"
            v-on:keydown.enter.prevent="simpan()"
          ></b-form-input>
        </b-form-group>
      </b-form>
      <template #modal-footer>
        <b-button variant="secondary" @click="$bvModal.hide('modal-edit')">
          {{ $store.state.form.batal }}
        </b-button>
        <b-button variant="primary" :disabled="busy || !isValid" @click="simpan()">
          {{ button }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, requiredIf } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
export default {
  name: "modalEdit",
  props: ["data", "listKategoriShift", "listMitra"],
  data() {
    return {
      listLembur: [],
      listKoordinator: [],
      listCabang: [],
      listCapem: [],
      busy: false,
      button: "Simpan",
    };
  },
  computed: {
    ...mapGetters(["lang"]),
    formString() {
      return JSON.stringify(this.data, null, 4);
    },
    isValid() {
      return !this.$v.data.$invalid;
    },
    isDirty() {
      return this.$v.data.$anyDirty;
    },
  },
  mixins: [validationMixin],
  validations: {
    data: {
      mitra: { required },
      koordinator: { required },
      cabang: { required },
      lembur: {
        required: requiredIf(function () {
          return this.data && this.data.kategoriShift && this.data.kategoriShift.lembur;
        }),
      },
      kategoriShift: { required },
      namaShift: { required },
      jamMasuk: { required },
      jamKeluar: { required },
      nominalUpah: { required },
    },
  },
  methods: {
    checkIfValid(fieldName) {
      const field = this.$v.data[fieldName];
      if (field.$invalid) {
        // console.log(fieldName);
      }

      if (!field.$dirty) {
        return null;
      }
      return !(field.$invalid || field.$model === "");
    },
    async showModal() {
      const vm = this;
      // vm.data.mitra = null
      // vm.data.koordinator = null
      // vm.data.cabang = null
      for (let i = 0; i < vm.listMitra.length; i++) {
        const x = vm.listMitra[i];
        console.log(x.id, vm.data, "mitra");
        if (x.id == vm.data.mitraId) {
          vm.data.mitra = x;
          await this.getKoordinator(this.data.mitra);
          await this.getLembur(this.data.mitra);
          break;
        }
      }
      for (let i = 0; i < vm.listKoordinator.length; i++) {
        const x = vm.listKoordinator[i];
        if (x.koordinatorId == vm.data.koordinatorId) {
          // console.log(x);
          vm.data.koordinator = x;
          await this.getCabang(this.data.koordinator);
          break;
        }
      }
      for (let i = 0; i < vm.listCabang.length; i++) {
        const x = vm.listCabang[i];
        if (x.cabangId == vm.data.cabangId) {
          vm.data.cabang = x;
          break;
        }
      }
    },
    async getLembur(x) {
      if (x) {
        let vm = this;
        const listLembur = await vm.$axios.post("masterLembur/list", { mitraId: x.id });
        vm.listLembur = listLembur.data.status == 200 ? listLembur.data.data : [];
      }
    },
    async getKoordinator(x) {
      if (x) {
        let koordinator = await this.$axios.get("koordinator/listKoordinatorByMitraId/" + x.id);
        this.listKoordinator = koordinator.data.status == 200 ? koordinator.data.data : [];
      }
    },
    async getCabang(x) {
      if (x) {
        let cabang = await this.$axios.get("cabang/listCabangByKoordinatorId/" + x.id);
        this.listCabang = cabang.data.status == 200 ? cabang.data.data : [];
      }
    },
    simpan() {
      let vm = this;
      if (vm.isValid) {
        vm.busy = true;
        vm.button = vm.$store.state.form.tunggu;
        vm.$axios
          .post("masterShift/update", {
            ...vm.data,
            kategoriShift: vm.data.kategoriShift.namaKategoriShift,
            warna: vm.data.kategoriShift.warna,
            mitraId: vm.data.mitra.id,
            koordinatorId: vm.data.koordinator.koordinatorId,
            cabangId: vm.data.cabang.cabangId,
            masterLemburId: vm.data.lembur ? vm.data.lembur.masterLemburId : null,
            id: vm.data.masterShiftId,
          })
          .then((res) => {
            if (res.data.message == "sukses") {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              this.$v.$reset();
              vm.$emit("alertFromChild", {
                variant: "success",
                msg: "BERHASIL MENGUBAH DATA MASTER SHIFT",
                showing: true,
              });
              this.$bvModal.hide("modal-edit");
            } else {
              vm.button = vm.$store.state.form.simpan;
              vm.busy = false;
              vm.$emit("alertFromChild", {
                variant: "danger",
                msg: res.data.message.toUpperCase(),
                showing: true,
              });
            }
          })
          .catch((err) => {
            vm.button = vm.$store.state.form.simpan;
            vm.busy = false;
            vm.$emit("alertFromChild", {
              variant: "danger",
              msg: err.message.toUpperCase(),
              showing: true,
            });
          });
      }
    },
  },
  watch: {
    lang: function (val) {
      val;
      this.button = this.$store.state.form.simpan;
    },
  },
};
</script>
